// CustomSettingsPage component
import { 
  SettingsLayout,
  UserSettingsProfileCard,
  UserSettingsThemeToggle
} from '@backstage/plugin-user-settings';
import { UserNotificationSettingsCard } from '@backstage/plugin-notifications';
import { Page, Content, Header } from '@backstage/core-components';

/**
 * Componente personalizado que sólo muestra la pestaña General
 * Reemplaza completamente el UserSettingsPage original
 */
export const CustomSettingsPage = () => {
  return (
    <Page themeId="home">
      {/* <Header title="Configuración" /> */}
      <Content>
        <SettingsLayout>
          <SettingsLayout.Route path="" title="General">
            <div>
              <UserSettingsProfileCard />
              <UserSettingsThemeToggle />
            </div>
          </SettingsLayout.Route>
          {/* <SettingsLayout.Route path="notifications" title="Notificaciones">
            <div>
              <UserNotificationSettingsCard 
                originNames={{ 'plugin:catalog': 'Catálogo' }} 
              />
            </div>
          </SettingsLayout.Route> */}
        </SettingsLayout>
      </Content>
    </Page>
  );
};
